import React, { useEffect, useState } from "react";
import axios from "../../axios";
import "../stylesheets/paymentsPageStyles.css";
import { withRouter } from "react-router-dom";
import validator from "validator";
import "react-bootstrap-typeahead/css/Typeahead.css";
import conversionImports from "../../googleScripts/conversionImports";
import { gtagHelperFunction } from "../Shared Components/gtagHelperFunction";
import { setInitiatePayment } from "../utils";
import CrmActions from "../../Shared Components/Crm/crmAction";
import SkeletonElement from "../../Skeletons/skeletonElement";
import { openLoginModal } from "../../utils";
import { Checkbox } from "semantic-ui-react";
import { MONGODB_BATCH_SLUG, DEFAULT_USER_COUNTRY } from "../constants";
import OfferLabel from "./offerLabel";
import { useSelector } from "react-redux";
// import OfferLabel from "./offerLabel";

function getRegistrationButton(
  batch,
  handleRegisteredUser,
  handleToUpdate,
  isThreeNinetyExempted
) {
  const {
    register_button: {
      action,
      sub_action: subAction,
      extra: {
        batch_url: batchUrl,
        contest_url: contestUrl,
        payment_start_date: paymentStartDate,
        reg_start_date: regStartDate,
      } = {},
    } = {},
  } = batch || {};

  const BUTTON_DATA = {
    user_already_registered_in_batch: {
      show_tracks: {
        text: "Start Course",
        onClick: () => (window.location = batchUrl),
      },
      fee_paid_batch_not_started: {
        text: "Batch not Started",
        isDisabled: true,
      },
      subscribed: {
        // text: isThreeNinetyExempted ? "Pay Fee" : "Avail Refund",
        text: "Pay Fee",
        onClick: () => {
          gtagHelperFunction(
            "click",
            "course_payfee_top",
            window.location.href
          );
          handleRegisteredUser(batch);
          setInitiatePayment();
        },
      },
      pay_fee: {
        // text: isThreeNinetyExempted ? "Pay Fee" : "Avail Refund",
        text: "Complete Payment",
        onClick: () => {
          gtagHelperFunction(
            "click",
            "course_payfee_top",
            window.location.href
          );
          handleRegisteredUser(batch);
          setInitiatePayment();
        },
      },
      attend_contest: {
        text: "Attend Contest",
        onClick: () => (window.location = contestUrl),
      },
      payment_link_will_open_on: {
        text: `Payment Link opens on ${paymentStartDate?.split("T")[0]}`,
        isDisabled: true,
      },
      payment_link_closed: {
        text: "Payment Link Closed",
        isDisabled: true,
      },
      no_seats_available: {
        text: "Seats not Available",
        isDisabled: true,
      },
      registration_closed: {
        text: "Registration Closed",
        isDisabled: true,
      },
    },
    registration_not_started: {
      text: `Registration starts on ${regStartDate?.split("T")[0]}`,
      isDisabled: true,
    },
    registration_closed: {
      text: "Registration Closed",
      isDisabled: true,
    },
    registration_open: {
      subscribe: {
        text: "Subscribe",
        isDisabled: true,
        onClick: () => handleToUpdate(batch),
      },
      sign_up_now: {
        // text: isThreeNinetyExempted ? "Save & Continue" : "Avail Refund",
        text: "Save & Continue",
        submitForm: true,
        onClick: () => {
          gtagHelperFunction(
            "click",
            "course_signup_top",
            window.location.href
          );
          // handleToUpdate(batch);
        },
      },
      registration_closed: {
        text: "Registration Closed",
        isDisabled: true,
      },
      free_course: {
        text: "Save & Continue",
        submitForm: true,
        onClick: () => {
          gtagHelperFunction("click", "course_reg_top", window.location.href);
          // handleToUpdate(batch);
        },
      },
    },
  };

  return BUTTON_DATA[action]?.[subAction] || BUTTON_DATA[action];
}

function getRegistrationButtonForSelfPacedCourse(
  batch,
  handleRegisteredUser,
  handleToUpdate,
  isThreeNinetyExempted
) {
  const {
    register_btn: {
      action,
      sub_action: subAction,
      extra: {
        batch_url: batchUrl,
        contest_url: contestUrl,
        payment_start_date: paymentStartDate,
        redirect_url: redirectUrl,
      } = {},
    } = {},
    batch_id,
    batch_name,
    start_date,
    batch_slug,
    show_invite_code_block,
    reg_start_date: regStartDate,
  } = batch || {};

  const batchRecord = {
    batch_id,
    batch_name,
    start_date,
    batch_slug,
    show_invite_code_block,
  };

  const BUTTON_DATA = {
    user_already_registered_in_batch: {
      show_tracks: {
        text: "Start Course",
        onClick: () => (window.location = batchUrl),
      },
      fee_paid_batch_not_started: {
        text: "Batch not Started",
        isDisabled: true,
      },
      subscribed: {
        // text: isThreeNinetyExempted ? "Pay Fee" : "Avail Refund",
        text: "Pay Fee",
        onClick: () => {
          gtagHelperFunction(
            "click",
            "course_payfee_top",
            window.location.href
          );
          handleRegisteredUser(batchRecord);
          setInitiatePayment();
        },
      },
      pay_fee: {
        // text: isThreeNinetyExempted ? "Pay Fee" : "Avail Refund",
        text: "Complete Payment",
        onClick: () => {
          gtagHelperFunction(
            "click",
            "course_payfee_top",
            window.location.href
          );
          handleRegisteredUser(batchRecord);
          setInitiatePayment();
        },
      },
      attend_contest: {
        text: "Attend Contest",
        onClick: () => (window.location = contestUrl),
      },
      payment_link_will_open_on: {
        text: `Payment Link opens on ${paymentStartDate?.split("T")[0]}`,
        isDisabled: true,
      },
      payment_link_closed: {
        text: "Payment Link Closed",
        isDisabled: true,
      },
      no_seats_available: {
        text: "Seats not Available",
        isDisabled: true,
      },
      registration_closed: {
        text: "Registration Closed",
        isDisabled: true,
      },
      registration_not_started: {
        text: `Registration starts on ${regStartDate?.split("T")[0]}`,
        isDisabled: true,
      },
    },
    registration_not_started: {
      text: `Registration starts on ${regStartDate?.split("T")[0]}`,
      isDisabled: true,
    },
    registration_closed: {
      text: "Registration Closed",
      isDisabled: true,
    },
    registration_open: {
      subscribe: {
        text: "Subscribe",
        onClick: () => handleToUpdate(batchRecord),
      },
      sign_up_now: {
        text: "Save & Continue",
        // text: isThreeNinetyExempted ? "Save & Continue" : "Avail Refund",
        submitForm: true,
        onClick: () => handleToUpdate(batchRecord),
      },
      registration_closed: {
        text: "Registration Closed",
        isDisabled: true,
      },
      free_course: {
        text: "Register Now",
        submitForm: true,
        onClick: () => handleToUpdate(batchRecord),
      },
    },
    redirect: {
      text: "Start Course",
      onClick: () => (window.location = redirectUrl),
    },
  };

  return BUTTON_DATA[action]?.[subAction] || BUTTON_DATA[action];
}

function FillDetailsComponent(props) {
  const {
    userDetails,
    upcomingBatches,
    handleFillDetailsUpdate,
    handleSelfPacedCourseRegisteredUser,
    paymentsPageSetState,
    handleToUpdate,
    courseId,
    updateUserDetailsState,
    isUpcomingBatchesContainerHidden,
    isLoggedIn,
    data: {
      course_type: courseType,
      courseFeeType,
      showInviteCodeBlock,
      batchID: selectedBatchId,
      // batchStartDate,
      courseName,
    } = {},
    isUsersGitHubAccount,
  } = props;

  const [name, setName] = useState();
  const [parentName, setParentName] = useState(undefined);
  const [email, setEmail] = useState();
  const [mobileNo, setMobileNo] = useState();
  const [country, setCountry] = useState(DEFAULT_USER_COUNTRY);
  const [graduationYear, setGraduationYear] = useState("");
  const [hasData, setHasData] = useState(false);
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [invitationCode, setInvitationCode] = useState("");
  const [isRegisterButtonClicked, setIsRegisterButtonClicked] = useState(false);
  const [countryCallingCodeList, setCountryCallingCodeList] = useState({});
  const [regError, setRegError] = useState("");
  const [isKidsCourse, setIsKidsCourse] = useState(true);
  const [grade, setGrade] = useState(undefined);

  const [isInitialLoad, setIsInitialLoad] = useState(true);

  const [buttonData, setButtonData] = useState();
  const [selectedBatch, setSelectedBatch] = useState();
  //mongo db batch
  const [isMongoDbBatch, setIsMongoDbBatch] = useState(false);
  const [isChecked, setIsChecked] = useState(true);

  function handleRegisteredUser(batch) {
    CrmActions.updateUserAction(courseId, batch.batch_id, 1, 1);
    handleToUpdate(batch);
    handleFillDetailsUpdate(batch);
  }

  useEffect(() => {
    if (!selectedBatchId) return;

    const selectedBatchObject = upcomingBatches?.find(
      (b) => b.batch_id === selectedBatchId
    );

    if (selectedBatchObject?.batch_slug === MONGODB_BATCH_SLUG) {
      setIsMongoDbBatch(true);
    }

    setSelectedBatch(selectedBatchObject);

    const btnData =
      courseType === 1 // for self paced
        ? getRegistrationButtonForSelfPacedCourse(
            selectedBatchObject,
            handleSelfPacedCourseRegisteredUser,
            handleToUpdate
            // isThreeNinetyExempted
          )
        : getRegistrationButton(
            selectedBatchObject,
            handleRegisteredUser,
            handleToUpdate
            // isThreeNinetyExempted
          );

    setButtonData(btnData);
  }, [selectedBatchId, upcomingBatches]);

  useEffect(() => {
    setRegError("");

    if (selectedBatchId && email && !isUpcomingBatchesContainerHidden) {
      setTimeout(() => {
        document
          .querySelector(".registration_form_container")
          ?.scrollIntoView({ behavior: "smooth" });
      }, [100]);
    }
  }, [selectedBatchId, email, isUpcomingBatchesContainerHidden]);

  useEffect(() => {
    if (
      upcomingBatches?.length &&
      isInitialLoad &&
      selectedBatchId &&
      !isUpcomingBatchesContainerHidden
    ) {
      setTimeout(() => {
        document
          .querySelector(`.option.batch-${selectedBatchId}`)
          ?.scrollIntoView({ behavior: "smooth", block: "center" });
      }, [50]);

      setIsInitialLoad(false);
    }
  }, [
    upcomingBatches,
    isInitialLoad,
    selectedBatchId,
    isUpcomingBatchesContainerHidden,
  ]);

  useEffect(() => {
    if (isLoggedIn === false) openLoginModal();
  }, [isLoggedIn]);

  useEffect(() => {
    if (!userDetails || email) return;

    const isValidCountry =
      userDetails?.country &&
      userDetails?.country_calling_code_list[userDetails?.country];
    if (isValidCountry) setCountry(userDetails?.country);
    setMobileNo(userDetails.phone);
    setEmail(userDetails.email);
    if (userDetails?.email?.length > 0) {
      if (!validator.isEmail(userDetails.email)) setIsEmailValid(false);
    }
    setCountryCallingCodeList(userDetails.country_calling_code_list);
    setName(userDetails.name);
    setParentName(userDetails.guardian_name);
    setGrade(userDetails.grade);
    let gradYear = userDetails.graduation_year
      ? userDetails.graduation_year
      : "";
    setGraduationYear(gradYear);
    props.setGraduationYear(gradYear);
    setHasData(true);
    setIsKidsCourse(props.is_kids_course);
  }, [userDetails, email]);

  const submitHandler = (e) => {
    e.preventDefault();
    setIsRegisterButtonClicked(true);
    conversionImports();
    registerUser();
  };

  const onChangePhoneNo = (e) => {
    const value = e.target.value;

    // max 15 digits to be allowed
    if (value?.length > 15) return;

    setMobileNo(value);
    updateUserDetailsState({
      name: "phone",
      value,
    });
  };

  function getCountryCodes() {
    var options = [];
    options.push(
      <option value="" key="-1">
        Select Country
      </option>
    );
    Object.keys(countryCallingCodeList).forEach((temp, index) => {
      options.push(
        <option key={index} value={temp}>
          {temp + ": " + countryCallingCodeList[temp]}
        </option>
      );
    });
    return options;
  }

  function getGrades() {
    var options = [];
    options.push(
      <option value="" key="-1">
        Select Grade
      </option>
    );
    for (let i = 1; i <= 12; i++) {
      options.push(
        <option key={i} value={i}>
          {i}
        </option>
      );
    }
    options.push(
      <option value="13" key="13">
        12+ (12th Pass)
      </option>
    );
    return options;
  }

  async function gtag_report_conversion(eventId) {
    try {
      window.gtag("event", "conversion", {
        send_to: eventId,
      });
    } catch (error) {
      console.log(error);
    }
  }

  async function registerUser() {
    if (isMongoDbBatch && !isChecked) {
      return null;
    }
    setIsRegisterButtonClicked(true);
    // reset error message
    setRegError("");
    var data = {
      fullname: name,
      // user_institute: workplace,
      phone_number: mobileNo,
      // state_id: country === "India" ? selectedState : "",
      batch: props.data.batchID,
      invitation_code: invitationCode,
      country: country,
      country_calling_code: countryCallingCodeList[country],
      page_url: window.location.href,
      http_referrer: document.referrer,
    };
    const gcl_id = document.getElementById("gclid_field");
    if (gcl_id && gcl_id.value && gcl_id.value.length > 1)
      data["gclId"] = gcl_id.value;
    if (isKidsCourse) {
      data["guardian_name"] = parentName;
      data["grade"] = String(grade);
    } else {
      // data["user_profession"] = profession;
      data["passing_year"] = graduationYear;
    }
    const queryParams = new URLSearchParams(window?.location?.search);
    const coupon = queryParams.get("coupon");
    if (coupon) {
      data["coupon"] = coupon;
    }

    await axios
      .post("/batch-registration/", data, {
        params: {
          coupon: coupon,
        },
      })
      .then((res) => {
        setRegError("");
        const keyToBeUpdated =
          courseType === 1 ? "register_btn" : "register_button";
        const payFeeAction = res.data.pay_fee.action;
        if (payFeeAction === "link_open") {
          const queryParams = new URLSearchParams(window.location.search);
          if (!queryParams.get("reg")) {
            queryParams.append("reg", true);
            props.history.replace(
              `${props.history.location.pathname}?${queryParams.toString()}`
            );
          }
          handleFillDetailsUpdate();
        } else if (
          ["link_will_open_on", "link_closed"].includes(payFeeAction)
        ) {
          paymentsPageSetState({
            upcomingBatches: upcomingBatches.map((currBatch) => {
              if (currBatch.batch_id === selectedBatchId) {
                currBatch[keyToBeUpdated] = {
                  ...currBatch[keyToBeUpdated],
                  action: "user_already_registered_in_batch",
                  sub_action:
                    payFeeAction === "link_will_open_on"
                      ? "payment_link_will_open_on"
                      : "payment_link_closed",
                  extra:
                    payFeeAction === "link_will_open_on"
                      ? {
                          ...(currBatch?.[keyToBeUpdated]?.extra || {}),
                          payment_start_date: res.data.pay_fee.date,
                        }
                      : undefined,
                };
              }
              return currBatch;
            }),
          });
          setIsRegisterButtonClicked(false);
        } else if (payFeeAction === "free_course") {
          window.location.href = decodeURIComponent(
            res.data.pay_fee.batch_page_url
          );
        }
        gtag_report_conversion(props.adEventId);
        gtagHelperFunction(
          "register",
          "courseregform_savenext",
          window.location.href
        );
      })
      .catch((err) => {
        const err_msg = err?.response?.data?.error?.message;
        if (err_msg) setRegError(err_msg);
        setIsRegisterButtonClicked(false);
      });
  }

  function handleEmailChange(e) {
    setEmail(e.target.value);
    updateUserDetailsState({ name: "email", value: e.target.value });
    if (!validator.isEmail(e.target.value)) setIsEmailValid(false);
    else setIsEmailValid(true);
  }

  function handleCountryChange(e) {
    setCountry(e.target.value);
    updateUserDetailsState({ name: "country", value: e.target.value });
    updateUserDetailsState({
      name: "country_calling_code",
      value: countryCallingCodeList[e.target.value],
    });
  }

  return (
    <div>
      <section id="detailsComponent" className="registration_form_container">
        <>
          {isUpcomingBatchesContainerHidden && (
            <div className="selected_batch_details">
              {props?.promotionalUpcomingEvents?.payments_registration_pill &&
              courseFeeType === 1 ? (
                <OfferLabel
                  classes="for_payment_details_card on_right"
                  text={
                    props?.promotionalUpcomingEvents
                      ?.payments_registration_pill?.[0]?.title
                  }
                />
              ) : null}

              <div>
                <h6>Registering For</h6>
                <h2>{courseName}</h2>
              </div>
              <div className="batch_info">
                <h6>Batch</h6>
                <h2>{selectedBatch?.batch_name || "-"}</h2>
              </div>
            </div>
          )}
          <div id="personalDetails" className="registration_form">
            {(hasData && buttonData) || isLoggedIn === false ? (
              <>
                {isLoggedIn === false && (
                  <>
                    <div className="blurred" />

                    <div className="login_message">
                      <p>
                        Please <span onClick={openLoginModal}>login</span> to
                        continue.
                      </p>
                    </div>
                  </>
                )}
                <h4 className="main_heading">Registration Details</h4>
                <form onSubmit={(e) => submitHandler(e)}>
                  {!isKidsCourse ? (
                    <>
                      <div className="row">
                        <div className="form-group col-12">
                          <label className="float-left text-muted required">
                            Full Name
                          </label>
                          <input
                            type="text"
                            value={name}
                            className="form-control justify-content-bottom"
                            onChange={(e) => setName(e.target.value)}
                            required
                            id="course-reg-name"
                            disabled={!buttonData?.submitForm}
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="form-group col-12">
                          <label
                            className={`float-left text-muted ${
                              !isUsersGitHubAccount ? "required" : ""
                            }`}
                          >
                            Email Id
                          </label>
                          <input
                            type="email"
                            disabled
                            className="form-control"
                            value={isUsersGitHubAccount ? "" : email}
                            onChange={handleEmailChange}
                            required={!isUsersGitHubAccount}
                            id="course-reg-email"
                          />
                          {!isEmailValid && !isUsersGitHubAccount && (
                            <p className="text-left text-danger mt-1">
                              Invalid Email
                            </p>
                          )}
                        </div>
                      </div>

                      <div className="row">
                        <div className="form-group col-5">
                          <label
                            for="course-reg-country"
                            className="float-left text-muted required"
                          >
                            Country
                          </label>
                          <select
                            value={country}
                            class="form-control"
                            onChange={handleCountryChange}
                            id="course-reg-country"
                            required
                            disabled={!buttonData?.submitForm}
                          >
                            {getCountryCodes()}
                          </select>
                        </div>

                        <div className="form-group col-7 pl-0">
                          <label className="float-left text-muted required">
                            Phone Number
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            value={mobileNo}
                            onChange={onChangePhoneNo}
                            required
                            id="course-reg-phoneno"
                            disabled={!buttonData?.submitForm}
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="form-group col-12">
                          <label className="float-left text-muted required">
                            Graduation Year
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            value={graduationYear}
                            onChange={(e) => {
                              setGraduationYear(e.target.value);
                              props.setGraduationYear(e.target.value);
                            }}
                            required
                            id="course-reg-gradyear"
                            disabled={!buttonData?.submitForm}
                          />
                        </div>
                      </div>

                      <div className="row">
                        {showInviteCodeBlock && (
                          <div className="form-group col-12">
                            <label className="float-left text-muted">
                              Invitation Code
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={invitationCode}
                              onChange={(e) =>
                                setInvitationCode(e.target.value)
                              }
                              required
                              disabled={!buttonData?.submitForm}
                            />
                          </div>
                        )}
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="row">
                        <div className="form-group col-12">
                          <label className="float-left text-muted required">
                            Student Name
                          </label>
                          <input
                            type="text"
                            value={name}
                            className="form-control justify-content-bottom"
                            onChange={(e) => setName(e.target.value)}
                            required
                            id="course-reg-name"
                            disabled={!buttonData?.submitForm}
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="form-group col-12">
                          <label
                            className={`float-left text-muted ${
                              !isUsersGitHubAccount ? "required" : ""
                            }`}
                          >
                            Email Id
                          </label>
                          <input
                            type="email"
                            disabled
                            className="form-control"
                            value={isUsersGitHubAccount ? "" : email}
                            onChange={handleEmailChange}
                            required={!isUsersGitHubAccount}
                            id="course-reg-email"
                          />
                          {!isEmailValid && !isUsersGitHubAccount && (
                            <p className="text-left text-danger mt-1">
                              Invalid Email
                            </p>
                          )}
                        </div>
                      </div>

                      <div className="row">
                        <div className="form-group col-12">
                          <label className="float-left text-muted required">
                            Standard
                          </label>
                          <select
                            value={grade}
                            class="form-control"
                            onChange={(e) => setGrade(e.target.value)}
                            id="exampleFormControlSelect1"
                            required
                            disabled={!buttonData?.submitForm}
                          >
                            {getGrades()}
                          </select>
                        </div>
                      </div>
                      <div className="row">
                        <div className="form-group col-5">
                          <label
                            for="course-reg-country"
                            className="float-left text-muted required"
                          >
                            Country
                          </label>
                          <select
                            value={country}
                            class="form-control"
                            onChange={handleCountryChange}
                            id="course-reg-country"
                            required
                            disabled={!buttonData?.submitForm}
                          >
                            {getCountryCodes()}
                          </select>
                        </div>
                        <div className="form-group col-7 pl-0">
                          <label className="float-left text-muted required">
                            Phone Number
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            value={mobileNo}
                            onChange={onChangePhoneNo}
                            required
                            id="course-reg-phoneno"
                            disabled={!buttonData?.submitForm}
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="form-group col-12">
                          <label className="float-left text-muted">
                            Parent Name
                          </label>
                          <input
                            type="text"
                            value={parentName}
                            className="form-control justify-content-bottom"
                            onChange={(e) => setParentName(e.target.value)}
                            disabled={!buttonData?.submitForm}
                          />
                        </div>
                      </div>

                      {showInviteCodeBlock && (
                        <div className="row">
                          <div className="form-group col-12">
                            <label className="float-left text-muted">
                              Invitation Code
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={invitationCode}
                              onChange={(e) =>
                                setInvitationCode(e.target.value)
                              }
                              required
                              disabled={!buttonData?.submitForm}
                            />
                          </div>
                        </div>
                      )}
                    </>
                  )}

                  <div className="row">
                    {/* ===========Hidden input for google Offline conversions============ */}
                    <input
                      type="hidden"
                      id="gclid_field"
                      name="gclid_field"
                      value=""
                    />
                    {/* ==================================================================*/}
                  </div>

                  {regError && regError?.length > 0 && (
                    <div className="row">
                      <div className="form-group col-12">
                        <p className="text-danger reg_err_msg">{regError}</p>
                      </div>
                    </div>
                  )}

                  {isMongoDbBatch && (
                    <div className="checkBox">
                      <Checkbox
                        disabled={!buttonData?.submitForm}
                        onChange={(e, { checked }) => {
                          setIsChecked(checked);
                        }}
                        checked={isChecked}
                        label="By enrolling in this course, you are giving your consent to us for sharing your personal data with MongoDB, which shall be further used for Certifications and Course update purposes. "
                      />
                    </div>
                  )}

                  <div className="row cta_container">
                    <div className="form-group col-12 text-center">
                      <button
                        type={buttonData?.submitForm ? "submit" : "button"}
                        disabled={
                          (!isEmailValid && !isUsersGitHubAccount) ||
                          isRegisterButtonClicked ||
                          buttonData?.isDisabled ||
                          (isMongoDbBatch ? !isChecked : false)
                        }
                        className={`register_btn ${
                          buttonData?.isDisabled ? "is_disabled" : ""
                        }`}
                        onClick={() => {
                          if (buttonData?.onClick) buttonData.onClick();
                          return null;
                        }}
                      >
                        {isLoggedIn === false
                          ? "Save & Continue"
                          : buttonData?.text}
                      </button>
                    </div>
                  </div>
                  <div className="terms-conditions row">
                    <p className="col-12">
                      By Registering, you agree to our{" "}
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.geeksforgeeks.org/privacy-policy/"
                      >
                        Privacy Policy
                      </a>{" "}
                      and{" "}
                      <a target="_blank" href="/terms-of-service">
                        Terms & Conditions
                      </a>
                      .
                    </p>
                  </div>
                </form>
              </>
            ) : (
              <div className="registration_form_shimmer">
                <div className="header_shimmer">
                  <SkeletonElement type="main_heading_shimmer" />
                </div>
                {[...new Array(4)].map((_, i) => (
                  <div className="field_shimmer" key={i}>
                    <SkeletonElement type="label_shimmer" />
                    <SkeletonElement type="input_shimmer" />
                  </div>
                ))}
                <SkeletonElement type="cta_shimmer" />
              </div>
            )}
          </div>
        </>
      </section>
    </div>
  );
}

export default withRouter(FillDetailsComponent);
